// extracted by mini-css-extract-plugin
module.exports = {"mainHome":"home_mainHome__kGSoW","topHome":"home_topHome__6o49i","titleContainer":"home_titleContainer__LD__F","presentGenerator":"home_presentGenerator__64p0G"};